import React, { useEffect } from 'react'

import { getSizedImageUrl } from '../../../../../scripts/utils/image'
import { SUBSCRIPTION_TYPES } from '../../../../context/subBuilder/constants'

import { useSubBuilder } from '../../../../context/subBuilder/useSubBuilder'
import GreyBoxYellowBoxSwitcheroo from '../components/GreyBoxYellowBoxSwitcheroo'
import SubBuilderStep from '../components/SubBuilderStep'


const Who: React.FunctionComponent = () => {
  const { settings, actions } = useSubBuilder()

  const stepConfig = settings.steps.who

  const removeQuery = () => {
    setTimeout(() => {
      const urlWithoutQueryParam = window.location.href.split('?')[0];
      window.history.replaceState({}, document.title, urlWithoutQueryParam);
    }, 500);
  }

  // This checks the current query params and sends you to the correct step based on what re-direct you're on.
  useEffect(() => {
    const getQueryParam = (name) => {
      const urlSearchParams = new URLSearchParams(window.location.search);
      return urlSearchParams.get(name) || '';
    };

    const type = getQueryParam('type');

    if (type === 'gift') {
      actions.setSubscriptionType('gift');
      removeQuery();
    } else if (type === 'me') {
      actions.setSubscriptionType('me');
      removeQuery();
    }
  }, [actions]);

  return (
    <SubBuilderStep className="sub-builder-container-sm sub-builder-who" index={1} stepConfig={stepConfig}>
      {
        SUBSCRIPTION_TYPES.map((subscriptionType, i) => (
          <button id={`sub-builder-btn-who-${i}`} className="sub-builder-btn sub-builder-btn-who" key={subscriptionType} type="button" onClick={async () => {
            actions.setSubscriptionType(subscriptionType)
          }}>
            {subscriptionType === 'gift' && (
              <>
                <GreyBoxYellowBoxSwitcheroo className="sub-builder-btn-img sub-builder-gift-img">
                  <img src={getSizedImageUrl(stepConfig.settings.giftImage, '300x300')} data-lazy-load />
                  <img className="img-hover" src={getSizedImageUrl(stepConfig.settings.giftImageHover, '300x300')} data-lazy-load />
                </GreyBoxYellowBoxSwitcheroo>
                <span className="sub-builder-btn-title text-upper">{ stepConfig.strings.giftText }</span>
              </>
            )}
            {subscriptionType === 'me' && (
              <>
                <GreyBoxYellowBoxSwitcheroo className="sub-builder-btn-img">
                  <img src={getSizedImageUrl(stepConfig.settings.forMeImage, '300x300')} data-lazy-load />
                </GreyBoxYellowBoxSwitcheroo>
                <span className="sub-builder-btn-title text-upper">{ stepConfig.strings.forMeText }</span>
              </>
            )}
          </button>
        ))
      }
    </SubBuilderStep>
  )
}
export default Who
